import React from 'react';
import {BooleanField, Datagrid, List, TextField} from 'react-admin';

const DietTypeCategoryList = (props) => {
    return (
        <List {...props}>
            <Datagrid rowClick="show">
                <TextField source="name" />
                <BooleanField addLabel source="completed" />
                <BooleanField addLabel source="deleted" />
            </Datagrid>
        </List>
    );
};

export default DietTypeCategoryList;